import WBS from 'js/http';
import is_json from 'js/is_json';
import toastr from 'toastr';

export default {
	data() {
		return {
			is_load: false,
			msgError: '',
			preRequestData: [],
			totalRegistros: 0,

			header: {
				pager: {
					page: 0,
					qnt: 50,
				},
				order: [],
				filter: null,
			},
		};
	},
	methods: {
		filter(filter) {
			this.header.filter = filter;
			this.requestServer();
		},
		GetClientDataFX(cnpj) {
			const client = this.preRequestData.find((item) => {
				if (item.cnpj.type == 'sst-viamed') {
					if (item.cnpj.sst_data.cnpj == cnpj) {
						return item;
					}
				} else {
					if (item.cnpj.client_data.cnpj == cnpj) {
						return item;
					}
				}
			});
			return client.cnpj.client_data || client.cnpj.sst_dat;
		},
		requestServer(callback = null) {
			// console.log(this.header)
			this.is_load = true;
			console.log(this.header);
			WBS.send(
				'private-read-sstServiceOrder',
				this.header,
				(resp) => {
					this.is_load = false;
					if (callback != null) callback();
					if (is_json(resp)) {
						resp = JSON.parse(resp);
						if (resp.status == 'error') {
							this.msgError = resp.msgs;
						} else if (resp.status == 'success') {
							this.preRequestData = resp.data.table;
							this.totalRegistros = resp.data.num_rows;
						}
					} else {
						toastr.error('A resposta não é JSON.');
						console.log(resp);
					}
				},
				'html'
			);
		},
		update() {
			this.requestServer();
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/order-of-service/js/loadFunctions.mixin.js